import PromotionCode from './PromotionCode'

export default PromotionCode
